import { sha256 } from 'js-sha256'

export const hashEmail = (email?: string | null) => (email ? sha256(email.toLowerCase().trim()) : undefined)
